module.exports = __webpack_public_path__ + "static/media/mr.3715287d.svg";